<template lang="pug">
.bq-service-layout(v-if="currentService")
    aside.bq-sidebar
        SideNav

    main.bq-main
        //- banners & warnings (shared across all service pages)
        ExpBanner

        EmailVerifyBanner

        .bq-warning(v-if="!currentService.service?.will_terminate && currentService.subscription?.will_cancel")
            span.material-symbols-outlined.bq-banner-icon(translate="no") warning
            span Subscription cancels on {{ currentService.subscription?.will_cancel }}.
            |
            router-link.bq-link(:to="`/subscription/${currentService.id}`") [Manage]

        .bq-warning.bq-warning--danger(v-if="currentService.service?.will_terminate")
            span.material-symbols-outlined.bq-banner-icon(translate="no") priority_high
            span Service deletes on {{ currentService.service?.will_terminate }}.
            |
            router-link.bq-link(:to="`/subscription/${currentService.id}`") [Resume plan]

        .bq-warning.bq-warning--danger(v-if="currentService.subscription?.status === 'past_due'" @click="openBillingPage" style="cursor:pointer")
            span.material-symbols-outlined.bq-banner-icon(translate="no") priority_high
            span Suspended due to payment issue. Click to manage billing.

        router-view

</template>

<script setup lang="ts">
import { useRoute, useRouter } from "vue-router";
import { onMounted, ref, watch } from "vue";
import { user, customer } from "@/code/user";
import { skapi } from "@/main";
import { fullScreenLoader } from "@/components/jsComponents";
import {
    currentService,
} from "@/views/project-list";
import {
    serviceIdList,
    serviceList,
    pullServices
} from "@/views/project-list";

import SideNav from "@/components/sideNav.vue";
import Modal from "@/components/modal.vue";
import ExpBanner from "@/components/expBanner.vue";
import EmailVerifyBanner from "@/components/emailVerifyBanner.vue";

const router = useRouter();
const route = useRoute();

let serviceId = route.path.split("/")[2];

async function run() {
    currentService.value = null;

    let isAwait = false;
    if (serviceId.startsWith("await-")) {
        isAwait = true;
        serviceId = serviceId.replace("await-", "");
    }

    let serviceInst = serviceList?.[serviceId];
    if (!serviceInst) {
        serviceInst = pullServices({ service_id_to_fetch: serviceId });
    }

    if (serviceInst instanceof Promise) {
        serviceInst = await serviceInst;
        if (isAwait) {
            router.push(`/my-projects/${serviceId}`);
        }
    }

    if (!serviceInst) {
        router.push('/my-projects');
        return;
    }

    currentService.value = serviceInst;
}
run();

let openBillingPage = async () => {
    fullScreenLoader();
    let resolvedCustomer = await customer;
    skapi
        .clientSecretRequest({
            clientSecretName: "stripe_test",
            url: `https://api.stripe.com/v1/billing_portal/sessions`,
            method: "POST",
            headers: {
                Authorization: "Bearer $CLIENT_SECRET",
                "Content-Type": "application/x-www-form-urlencoded",
            },
            data: {
                customer: resolvedCustomer.id,
                return_url: window.location.origin + route.path,
            },
        })
        .then((response) => {
            window.location = response.url;
        });
};
</script>

<style lang="less" scoped>
@import "@/assets/less/bq-tokens.less";

.bq-service-layout {
    display: flex;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    background: @paper;
    color: @ink;
    font-family: @mono;
}

.bq-sidebar {
    position: sticky;
    top: calc(4rem + var(--nav-top));
    width: 200px;
    flex-shrink: 0;
    overflow-y: auto;
    align-self: flex-start;
}

.bq-main {
    flex: 1;
    padding: 3rem 3rem 3rem;
    min-width: 0;
}

/* --- warning --- */
.bq-warning {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    border: 1px solid @warning-border;
    background: @warning-bg;
    color: @warning;
    font-size: 0.82rem;
    margin-bottom: 0.5rem;
    line-height: 1.5;

    &--danger {
        border-color: @danger;
        background: @danger-bg;
        color: @danger;
    }
}

.bq-link {
    &:hover {
        text-decoration: underline;
    }
}

@media (max-width: 800px) {
    .bq-sidebar {
        display: none;
    }

    .bq-main {
        padding: 1rem;
    }
}
</style>
